import { ActionTypes } from "../constants/actionType";
import api from "shared/utils/api";

export const setPageTitle = (pageTitle: string) => {
  return {
    type: ActionTypes.SET_PAGE_TITLE,
    payload: pageTitle,
  };
};
